import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';

import { SegmentedNavigationModule } from '../../components/segmented-navigation/segmented-navigation.module';
import { NewCustomTrackerModalModule } from './components/new-tracker-modal/new-custom-tracker-modal.module';
import { CustomTrackersComponent } from './custom-trackers.component';
import { CustomTrackersRoutingModule } from './custom-trackers-routing.module';
import { CustomTrackersListModule } from './routes/custom-trackers-list/custom-trackers-list.module';
import { CustomTrackersProfilModule } from './routes/custom-trackers-profil/custom-trackers-profil.module';

@NgModule({
  declarations: [CustomTrackersComponent],
  imports: [
    CommonModule,
    CustomTrackersRoutingModule,
    NewCustomTrackerModalModule,
    NgxBootstrapIconsModule,
    SegmentedNavigationModule,
    CustomTrackersListModule,
    CustomTrackersProfilModule,
  ],
})
export class CustomTrackersModule {}
